// @flow
import 'core-js/web';

import type { Location } from 'react-router-dom';

import env from 'utils/env';
import { trackElement } from '@nexus/fff-analytics';

const possibleQueryParams = [
  'category',
  'product_link',
  'searchedQuery',
  'campaign_id',
  'campaign_status',
  'inviteOpen',
  'ranMID',
  'ranSiteID',
  'utm_source',
  'utm_medium',
  'utm_campaign',
];

export type QueryParams = {|
  category: string | null,
  product_link: string | null,
  searchedQuery: string | null,
  campaign_id: string | null,
|};

type PossibleQueryParams = {|
  ...QueryParams,
  [string]: string | null,
|};

const emptyQueryParams: QueryParams = {
  category: null,
  product_link: null,
  searchedQuery: null,
  campaign_id: null,
};

export function getQueryParams(search: string): QueryParams {
  const urlSearchParams = new URLSearchParams(search);
  return possibleQueryParams.reduce(
    (queryParams, param) => {
      queryParams[param] = urlSearchParams.get(param);
      return queryParams;
    },
    { ...emptyQueryParams }
  );
}

export function getPathname(): string {
  return window.location.pathname;
}

export function getQueryParam(queryParamName: string) {
  return new URL(window.location.href).searchParams.get(queryParamName);
}

/**
 * Higher order function used in React Router Link to attribute
 * @param newQueryParams query params that should change
 * @return a function that can be passed to React Router Link to attribute
 */
export function updateLocationSearch(
  newQueryParams: $Shape<QueryParams>,
  state: {| accordionInGrid: boolean |} = { accordionInGrid: false }
) {
  return function updateLocation(location: Location) {
    const previousQueryParams = getQueryParams(location.search);
    const nextQueryParams = {
      ...previousQueryParams,
      ...newQueryParams,
    };
    const search = buildLocationSearch(nextQueryParams);
    return { ...location, search, state };
  };
}

export function buildLocationSearch(
  nextQueryParams: $Shape<PossibleQueryParams>
) {
  let locationSearch = '?';
  for (const queryParam in nextQueryParams) {
    const queryParamValue = nextQueryParams[queryParam];
    if (queryParamValue !== null) {
      locationSearch += `${queryParam}=${queryParamValue}&`;
    }
  }
  return locationSearch.slice(0, locationSearch.length - 1);
}

export function removeQueryParam(queryParamToRemove: QueryParams) {
  const currentQueryParams = getQueryParams(window.location.search);
  let locationSearch = '?';
  for (const queryParam in currentQueryParams) {
    if (queryParam === queryParamToRemove) {
      continue;
    }
    const queryParamValue = currentQueryParams[queryParam];
    if (queryParamValue !== null) {
      locationSearch += `${queryParam}=${queryParamValue}&`;
    }
  }
  return locationSearch.slice(0, locationSearch.length - 1);
}

export function trackAndRedirect(uri, elementName) {
  trackElement({ elementName });
  setTimeout(
    () => (window.location.href = `https://${env.hostname}/${uri}`),
    500
  );
}
